"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirstAvailableMonth = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var isDisabledDate_1 = require("./isDisabledDate");
var getFirstAvailableMonth = function (dates, startDate, disableStartDate) {
    if (disableStartDate === void 0) { disableStartDate = true; }
    var future = new Date(startDate);
    if (disableStartDate) {
        future.setDate(future.getDate() + 1);
    }
    while (dayjs_1.default(startDate).isSame(future, "month")) {
        if (!isDisabledDate_1.isDisabledDate(future, dates)) {
            return startDate;
        }
        future.setDate(future.getDate() + 1);
    }
    return future;
};
exports.getFirstAvailableMonth = getFirstAvailableMonth;
